import { Box, Typography } from '@mui/material';
import { ReturnLink } from '../../../components/ReturnLink';
import { SDLC_PATH } from '../../../config';
import { contentWidthSx, pageGutterSx } from '../../../theme';

// Renders inside the shell, below the AppBar — so it owns its gutters but not a
// full viewport height. A 404 that throws away the navigation is a dead end.
export const NotFoundPage = () => (
  <Box sx={{ ...pageGutterSx, flex: 1 }}>
    <Box sx={{ ...contentWidthSx, py: 12 }}>
      <Typography variant="h1" component="h1" gutterBottom>
        Page not found
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 6 }}>
        That page does not exist.
      </Typography>
      <ReturnLink to={SDLC_PATH} label="the toolkit" />
    </Box>
  </Box>
);
